export default "__VITE_ASSET__B$CS9Yif__"